const Book = () => {
    return (
        <div className="book">
            Book
        </div>
    );
};

export default Book;